(function () {
  if (window.__kpRevealInit) return;
  window.__kpRevealInit = true;

  function initReveal() {
    var els = document.querySelectorAll('[data-kp-reveal]');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('kp-in'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('kp-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var layers = document.querySelectorAll('[data-kp-parallax]');
    if (!layers.length) return;

    var ticking = false;
    function update() {
      var scrollY = window.scrollY || window.pageYOffset;
      layers.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var offset = (rect.top + scrollY) * 0.15;
        el.style.transform = 'translateY(' + Math.min(offset * 0.2, 60) + 'px) scale(1.06)';
      });
      ticking = false;
    }
    window.addEventListener(
      'scroll',
      function () {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      },
      { passive: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initReveal();
      initParallax();
    });
  } else {
    initReveal();
    initParallax();
  }

  document.addEventListener('shopify:section:load', function () {
    initReveal();
    initParallax();
  });
})();
